import React, { useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Fullscreen } from "@material-ui/icons";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { models } from "powerbi-client";
import styles from "./styles";

const PowerBi = ({ classes, accessToken, isLoading, match }) => {
  const [fullScreen, setFullScreen] = useState(false);
  const reportId = match.params.id;
  const handle = useFullScreenHandle();

  const enterFullScreen = (handle) => {
    handle.enter();
    setFullScreen(true);
  };

  return (
    <div>
      {isLoading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <FullScreen handle={handle}>
          <Button onClick={() => enterFullScreen(handle)}>
            <Fullscreen />
          </Button>
          <PowerBIEmbed
            embedConfig={{
              type: "report", // Supported types: report, dashboard, tile, visual and qna
              id: reportId,
              embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=e36677a5-c4b8-4b3d-a975-ee190b762327`,
              accessToken: `${accessToken}`,
              tokenType: models.TokenType.Aad,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                },
                //background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log(event.detail);
                  },
                ],
              ])
            }
            cssClassName={fullScreen ? classes.rootFullScreen : classes.root}
            //getEmbeddedComponent={(embeddedReport) => embeddedReport}
          />
        </FullScreen>
      )}
    </div>
  );
};

export default withStyles(styles)(PowerBi);
